import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";
import BasicLayout from "layouts/authentication/components/BasicLayout";
import bgImage from "assets/images/Signin-backgorund.png";

const apiUrl = process.env.REACT_APP_AUTH_API_URL;

function PasswordResetRequest() {
  const [email, setEmail] = useState("");
  const [snackbar, setSnackbar] = useState({
    open: false,
    title: "",
    message: "",
    color: "success",
    icon: "check",
  });

  const navigate = useNavigate();

  const closeSB = () => setSnackbar({ open: false });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`${apiUrl}/password_reset_request.php`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (!response.ok) {
        setSnackbar({
          open: true,
          title: "Error",
          message: data.message || "Something went wrong",
          color: "error",
          icon: "warning",
        });
        return;
      }

      setSnackbar({
        open: true,
        title: "Success",
        message: "Password reset link sent!",
        color: "success",
        icon: "check",
      });
    } catch (error) {
      console.error("There was a problem with the fetch operation:", error);
      setSnackbar({
        open: true,
        title: "Error",
        message: error.message || "There was an error submitting the form",
        color: "error",
        icon: "warning",
      });
    }
  };

  return (
    <BasicLayout image={bgImage}>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="secondary"
          borderRadius="lg"
          coloredShadow="info"
          mx={2}
          mt={-3}
          p={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            Password Reset
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form" onSubmit={handleSubmit}>
            <MDBox mb={2}>
              <MDInput
                label="Email"
                fullWidth
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </MDBox>
            <MDBox mt={4} mb={1}>
              <MDButton variant="gradient" color="secondary" fullWidth type="submit">
                Send Reset Link
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
      <MDSnackbar
        open={snackbar.open}
        color={snackbar.color}
        icon={snackbar.icon}
        title={snackbar.title}
        content={snackbar.message}
        onClose={closeSB}
        close={closeSB}
        bgWhite
      />
    </BasicLayout>
  );
}

export default PasswordResetRequest;
